"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const sensorCodeMap = {
    "H": "Humidity",
    "T": "Temperature",
    "MEA3": "Moisture Conductivity Analog V3",
    "IRO": "Deep Root",
    "LIA1": "Light Intensity Analog V1",
    "B": "Battery",
    "ST": "Soil Temperature",
    "IT": "Internal Temperature",
    "SS": "Signal Strength",
    "PS": "Power Status",
    "S": "Status",
    "M": "Moisture",
    "MA": "Moisture Analog",
    "MEA": "Moisture Conductivity Analog",
    "MEA0": "Moisture Conductivity Analog V0",
    "MEA1": "Moisture Conductivity Analog V1",
    "MEA2": "Moisture Conductivity Analog V2",
    "MEA4": "Moisture Conductivity Analog V4",
    "N": "Noise",
    "K": "Smoke",
    "V": "Vibration",
    "W": "Water",
    "G": "GPS",
    "BC": "Battery Charging",
    "RA": "Relative Age",
    "BL": "Battery Level",
    "RSSI": "Received Signal Strength Indicator",
    "NSR": "Noise Ratio",
    "LPG": "LPG Gas",
    "D": "Dust",
    "R": "Rain Drop",
    "O3": "O3",
    "CO": "CO",
    "DS": "Door Status",
    "LI": "Light Intensity",
    "LIA": "Light Intensity Analog",
    "CN": "Soil Conductivity",
    "CNA": "Soil Conductivity Analog",
    "PHA": "Ph Analog",
    "PH": "Ph",
    "CS": "Current Sensor",
    "E": "Energy",
    "L": "Location",
    "RL": "Relative Location",
    "HB": "Heart Beat",
    "X": "Test X",
    "Y": "Test Y",
    "RF": "Rainfall",
    "CRF": "Cumulative Rainfall",
    "EV": "Evaporation",
    "WD": "Wind Direction",
    "WS": "Wind Speed",
    "SI": "Sunshine Intensity",
    "P": "Pressure",
    "WI": "Wifi Signal Strength Indication",
    "CT": "Count",
    "CTD": "Count Discrete",
    "YC": "Yield Output Count",
    "CF": "Counter Overflow",
    "RT": "Real Time",
    "LS": "Log Synchronised",
    "CE_N": "Nitrogen",
    "CE_P": "Phosphorus",
    "CE_K": "Potassium",
    "N_ID": "Network ID",
    "GN": "Green",
    "RD": "Red",
    "YW": "Yellow",
    "C": "Operated Status",
    "A": "Alarm Status",
    "ID_MSG": "Message ID",
    "ID_IV": "Inv ID",
    "AP": "Sum Of Active Phases",
    "CP_A": "Phase A Current",
    "CP_B": "Phase B Current",
    "CP_C": "Phase C Current",
    "VP_AN": "V Phase A to N",
    "VP_BN": "V Phase B to N",
    "VP_CN": "V Phase C to N",
    "AC": "Total AC Power",
    "LF": "Line Frequency",
    "AC_AP": "AC Apparent Power",
    "AC_RP": "AC Reactive Power",
    "AC_PF": "AC Power Factor",
    "AC_E": "AC Energy",
    "DC_C": "DC Current",
    "DC_V": "DC Voltage",
    "DC_P": "DC Power",
    "OS": "Operating State",
    "V_PCC": "V to PCC",
    "S_PV": "PV Status",
    "S_ECP": "ECP Conn Status",
    "CC": "Conn Control",
    "T_RPI": "RPi Temperature",
    "T_C": "Cabinet Temperature",
    "S_D": "Status Description",
    "S_M": "Modbus Status",
    "S_U": "Update Status",
    "EF": "Event Fields",
    "LES": "Lora Error State",
    "S_ID": "Slave ID"
};
exports.mapSensorCodesToNames = (codes, sensorCodeList) => {
    return codes.map(code => {
        const found = sensorCodeList.find(item => item.code === code);
        return found ? found.codeValue : "Unknown";
    });
};
exports.mapSensorCodeToName = (code, sensorCodeList) => {
    const found = sensorCodeList.find(item => item.code === code);
    return found ? found.codeValue : "Unknown";
};
const sensorNameToCodeMap = Object.entries(sensorCodeMap).reduce((acc, [code, name]) => {
    acc[name] = code;
    return acc;
}, {});
exports.getSensorNamesToCode = (names, sensorCodeList) => {
    return names.map(name => {
        const found = sensorCodeList.find(item => item.codeValue === name);
        return found ? found.code : "Unknown";
    });
};
//# sourceMappingURL=getSensor.js.map